(function () {
  if (window.Shopify?.designMode) return;

  const main = document.getElementById('MainContent');
  const sections = main?.querySelectorAll('.shopify-section');
  if (!sections?.length) return;

  const nav = document.createElement('nav');
  nav.className = 'snap-nav';

  sections.forEach((section, i) => {
    const dot = document.createElement('button');
    dot.className = 'snap-nav__dot';
    dot.setAttribute('aria-label', `Section ${i + 1}`);
    dot.addEventListener('click', () => {
      section.scrollIntoView({ behavior: 'smooth' });
    });
    nav.appendChild(dot);
  });

  document.body.appendChild(nav);

  const dots = nav.querySelectorAll('.snap-nav__dot');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = Array.from(sections).indexOf(entry.target);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }
    });
  }, { root: main, threshold: 0.5 });

  sections.forEach(s => observer.observe(s));
})();